enum OriginParty {
    AppUser = 1,
    Admin = 2
}

export default OriginParty;
